goog.provide('el8.ptdata.model.ptInsurance');

goog.require('el8.model.base');


/**
 * Used by the patient model to hold a PatientInsurance.
 * Right now (11/15), a patient will only ever get a primary
 * and secondary insurance down from the server, but theoretically
 * a patient could have N of these.
 */
(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addAddressProperties();

    _class.addBoolean('nonEmpty');
    _class.addIntProperty('rank');

    // SWAT-3085 Add all fields to the model whether-or-not the practice is using FONK
    _class.addIntProperty('companyId', true);
    _class.addStringProperty('carrier', true);
    _class.addIntProperty('planId', true);
    _class.addStringProperty('plan', true);

    _class.addStringProperty('groupId', true);
    _class.addStringProperty('memberId', true);

    _class.addDecimalProperty('copay', true);
    _class.addDecimalProperty('deductible', true);

    _class.addStringProperty('insuredPersonFirstName', true);
    _class.addStringProperty('insuredPersonLastName', true);
    _class.addStringProperty('phone', true);
    _class.addStringProperty('extension', true);

    _class.addStringProperty('insuredPersonAddress', true);
    _class.addStringProperty('insuredPersonCity', true);
    _class.addStringProperty('insuredPersonState', true);
    _class.addStringProperty('insuredPersonZip', true);

    _class.addStringProperty('insuredPersonId', true);
    _class.addStringProperty('insuredPersonSsn', true);
    _class.addDate('insuredPersonDob', true);
    _class.addStringProperty('insuredPersonGender', true);

    _class.addStringProperty('paymentProgram', true);

    // Convenience prop for form map exctraction. Source of truth on the pt model
    _class.addStringProperty('patientEmployer', true);

    _class.addStringProperty('insuredPersonName', true);  // Deprecated in all cases now?
    _class.addStringProperty('relationshipToInsured', true);

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        spec.companyId = spec.insurance_company && spec.insurance_company.id;
        spec.carrier = spec.insurance_company && spec.insurance_company.carrier;
        spec.planId = spec.insurance_plan && spec.insurance_plan.id;
        spec.plan = spec.insurance_plan && spec.insurance_plan.name;
        // we're filling out these address fields for the purpose of hasAddressFilledOut
        spec.address = spec.insurance_company && spec.insurance_company.address;
        spec.city = spec.insurance_company && spec.insurance_company.city;
        spec.state = spec.insurance_company && spec.insurance_company.state;
        spec.zip = spec.insurance_company && spec.insurance_company.zip;

        this.parent.populate.call(this, spec);
    };

    _class.prototype.clone = function() {
        var copy = _.clone(this);
        copy.setId(null);
        return copy;
    };

    _class.prototype.getCarrierPlan = function() {
        var planStr = this.getCarrier();
        if (this.getPlan() && (planStr !== this.getPlan())) { // don't show "aetna aetna"
            if (el8Globals.FEATURES &&
                el8Globals.FEATURES.FrontOfficeNewKareo) {
                planStr += ' ' + this.getPlan(); // only append plan with flag
            }
        }
        return planStr;
    };

    /**
     * Check to see if the insurance has all the main address components filled out.
     * Does not include address line 2 (e.g. suite)
     *
     * @returns {boolean} whether the address is filled out or not
     */
    _class.prototype.hasAddressFilledOut = function() {
        return Boolean(((
            el8.ptdata.currPatient.getPrimaryInsurance().getAddress()
            && el8.ptdata.currPatient.getPrimaryInsurance().getCity()
            && el8.ptdata.currPatient.getPrimaryInsurance().getState()
            && el8.ptdata.currPatient.getPrimaryInsurance().getZip()
        )));
    };

    el8.ptdata.model.ptInsurance = function(spec) { return new _class(spec); };

})();
